import { CloudflareImage } from '../components/image.tsx';
import { TextLink } from '../components/link.tsx';
import { Skeleton } from '../components/skeleton.tsx';
import { Heading } from '../text/heading.tsx';
import type { ComponentProps, JSXElement, ParentProps } from 'solid-js';

type Props = ParentProps<{
	src: string;
	alt: string;
	title: JSXElement;
	href: string;
	loading?: ComponentProps<typeof CloudflareImage>['loading'];
}>;

export function ImageCard(props: Props) {
	return (
		<article class="group relative rounded-lg outline-0 outline-transparent transition-all hover:-translate-y-1 hover:bg-yellow-500/10 hover:outline-12 hover:outline-yellow-500/10 dark:hover:bg-yellow-500/20 dark:hover:outline-yellow-500/20">
			<div class="overflow-hidden rounded-lg">
				<CloudflareImage
					src={props.src}
					alt={props.alt}
					height={150}
					width={400}
					sizes="24rem"
					class="w-full bg-zinc-200 transition-transform group-hover:scale-105 dark:bg-zinc-800"
					format="webp"
					fit="cover"
					loading={props.loading}
				/>
			</div>
			<Heading level="h1" size="h5">
				<TextLink
					href={props.href}
					color="current"
					class="flex items-center gap-1 overflow-hidden text-nowrap text-ellipsis after:absolute after:inset-0"
				>
					{props.title}
				</TextLink>
			</Heading>
			{props.children}
		</article>
	);
}

export function ImageCardSkeleton(props: ParentProps) {
	return (
		<Skeleton class="relative flex flex-col gap-px rounded-lg">
			<div class="aspect-200/75 overflow-hidden rounded-lg">
				<Skeleton.Image darkness="dark" />
			</div>
			<Skeleton.Text class="text-lg" />
			{props.children}
		</Skeleton>
	);
}
